import FunctionEdge from "../edge/FunctionEdge";
import GenericEdge from "../edge/GenericEdge";

export const edgeTypes = {
  genericedge: GenericEdge,
  functionedge: FunctionEdge,
};
